import { render, staticRenderFns } from "./YSmingxi.vue?vue&type=template&id=56750e92&scoped=true&"
import script from "./YSmingxi.vue?vue&type=script&lang=js&"
export * from "./YSmingxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56750e92",
  null
  
)

export default component.exports